<template>
  <div class="mapsearch-wrap">
    <close-btn
      v-if="modal"
      class="btn-tertiary"
      @close="close"
    />
    <div class="text-center">
      <div
        v-show="showResultHint"
        id="resultHint"
        class="box p-1"
      >
        <template v-if="resultCount > 0 ">
          {{ $t('common:map.resultHint', { resultCount, totalCount:formatNumber(totalCount) }) }}
        </template>
        <template v-else>
          {{ $t('common:map.noResultHint') }}
        </template>
      </div>
      <button
        v-if="showReload && !spinning"
        type="button"
        class="btn btn-map-search"
        data-ident="mapSearch"
        @click="doSearch"
      >
        <i class="icon">
          <icon-redo />
        </i>
        {{ $t('common:map.search') }}
      </button>
      <button
        v-if="spinning"
        type="button"
        class="btn btn-map-search"
      >
        <i class="icon animated">
          <icon-redo />
        </i>
        {{ $t('common:map.loading') }}
      </button>
    </div>
  </div>
</template>
<script>
import IconRedo from 'ICON:IconRedo';
import CloseBtn from 'components/CloseButton.vue';
import getNumberFormat from 'mixins/composition/NumberFormat';

export default {
  name: 'MapSearchButton',
  i18nOptions: { namespaces: ['common'] },
  components: {
    IconRedo,
    CloseBtn,
  },
  props: {
    showReload: {
      type: Boolean,
      default: false,
    },
    modal: {
      type: Boolean,
      default: false,
    },
    animated: {
      type: Boolean,
      default: false,
    },
    resultCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  setup(_, ctx) {
    const { formatNumber } = getNumberFormat(ctx);
    return { formatNumber };
  },
  data() {
    return {
      clicked: false,
    };
  },
  computed: {
    spinning() {
      return this.animated || this.clicked;
    },
    showResultHint() {
      return this.totalCount === 0 || this.totalCount > this.resultCount;
    },

  },
  destroyed() {
    this.clicked = false;
  },

  methods: {
    doSearch() { // tell searchmap component
      this.clicked = true;
      setTimeout(() => {
        this.clicked = false;
      }, 2000);
      this.$emit('start-search');
    },
    close() {
      this.$emit('close-map');
    },
  },
};
</script>
<style lang="scss" scoped>
.animated {
  animation: pleasewaitspin 1.2s infinite linear;

  @keyframes pleasewaitspin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.mapsearch-wrap {
  width: 100%;
  position: absolute;
  top: 13px;
  z-index: 500;
  font-size: 1rem;
}

.btn-map-search {
  display: inline-block;
  padding: 0 1em 0 0;
  margin: 0;
  height: 2em;
  border: none;

  @include font_size_s;

  line-height: 1.9em;
  background: var(--color_ci);
  color: #fff;

  input {
    display: none;
  }

  .icon {
    @include radius(50%);

    margin: 0 0.5em 0 -1px;
    float: left;
    height: 2em;
    width: 2em;
    padding: 0;
    text-align: center;
    line-height: 2em;
    background: #fff;
    color: var(--color_ci);
  }

  #app:not(.isTouchDevice) &:hover,
  &.active {
    .icon {
      background: var(--color_ci);
      background: #fff;
      color: var(--color_ci);
    }
  }
}

#resultHint {
  text-align: center;
  z-index: 1006;
  width: 60%;
  max-width: 500px;
  margin: 0 auto 10px;

  @include radius($radius_card);

  opacity: 0.9;
  background: #fff;
}
</style>
